// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3U7tb","select":"Header_select__1cW2E","clinic":"Header_clinic__2Ly9r"};